import { Bot, Square } from 'lucide-react';
import { ThinkingBlock } from './ThinkingBlock';
import { MarkdownContent } from '../shared/MarkdownContent';

interface StreamingMessageProps {
  content: string;
  thinking: string;
  onStop?: () => void;
}

export function StreamingMessage({ content, thinking, onStop }: StreamingMessageProps) {
  return (
    <div className="flex gap-3">
      <div className="w-8 h-8 rounded-full bg-surface-700 flex items-center justify-center flex-shrink-0">
        <Bot className="w-4 h-4 text-text-muted" />
      </div>
      <div className="flex-1 max-w-[80%]">
        <div className="inline-block rounded-lg px-3 py-2 text-sm bg-surface-800 text-text-primary">
          {thinking && <ThinkingBlock content={thinking} />}
          {content ? (
            <MarkdownContent content={content} />
          ) : null}
          <span className="inline-block w-1.5 h-4 bg-primary-400 animate-pulse ml-0.5 align-middle" />
        </div>
        {onStop && (
          <button
            onClick={onStop}
            className="mt-2 flex items-center gap-1.5 text-xs text-text-muted hover:text-text-secondary transition-colors"
          >
            <Square className="w-3 h-3" />
            Stop
          </button>
        )}
      </div>
    </div>
  );
}
